import React from 'react';
import styled from 'styled-components';

const CDN_URL = process.env.REACT_APP_CDN_URL;

const bugDefault = `${CDN_URL}common/feedback/bug-select.svg`;
const ideaDefault = `${CDN_URL}common/feedback/idea-select.svg`;
const likeDefault = `${CDN_URL}common/feedback/like-select.svg`;

const FeedbackStyle = styled.div`
	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
			props.theme.res.high}) {
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
	}
`;

function getImage(type) {
	switch (type) {
		case 'BUG':
			return bugDefault;
		case 'IDEA':
			return ideaDefault;
		case 'LIKE':
			return likeDefault;
		default:
			return ideaDefault;
	}
}

function getSubTitle(type) {
	let subTitle;
	switch (type) {
		case 'BUG':
			subTitle = 'for reporting this bug.';
			break;
		case 'IDEA':
			subTitle = 'for your idea.';
			break;
		case 'LIKE':
			subTitle = 'for liking our portal.';
			break;
		default:
			subTitle = '';
			break;
	}
	return subTitle;
}

export const ConfirmationScreen = ({ selectedType, error }) => {
	return (
		<FeedbackStyle
			className='feedback-modal-confirmation-screen'
			id='feedback-modal-confirmation-screen'
		>
			{!error && (
				<>
					<img src={getImage(selectedType)} />
					<div className='title primary60'>THANK YOU</div>
					<div className='subtitle primary60'>{getSubTitle(selectedType)}</div>
				</>
			)}
			{error && (
				<>
					<img src={getImage(selectedType)} />
					<div className='title primary60'>Something went wrong.</div>
					<div className='subtitle primary60'>
						{error}
						<br />
						If the problem persists please call
						<br />
						877-590-1684.
					</div>
				</>
			)}
		</FeedbackStyle>
	);
};
